import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './App.jsx'
import { ThemeProvider } from './context/theme.jsx'
import { AuthProvider } from './context/auth.jsx'
import { TimezoneProvider } from './context/timezone.jsx'
import { BrandingProvider } from './context/branding.jsx'


ReactDOM.createRoot(document.getElementById('root')).render(
	<>
		<BrandingProvider>
			<ThemeProvider>
				<TimezoneProvider>
					<BrowserRouter>
						<AuthProvider>
							<App />
						</AuthProvider>
					</BrowserRouter>
				</TimezoneProvider>
			</ThemeProvider>
		</BrandingProvider>
	</>,
)
